<script setup>
  import {MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({name: "ComponentFakeInput"});

  defineProps({
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    helperText: {
      type: String,
      default: "",
    },
    withPlaceholder: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "-",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledText: {
      type: Boolean,
      default: false,
    },
  });
</script>

<template>
  <div :data-test="getTestId('fake-input')">
    <template v-if="label">
      <span class="origin-0 -z-1 cursor-default truncate text-sm text-gray-500 duration-300">
        {{ label }}
      </span>
    </template>

    <div
      class="h-9 truncate border-0 border-b-1 border-gray-300 p-2 text-sm"
      :class="{'border-dashed': disabled, 'text-gray-500': disabledText}"
    >
      <template v-if="!value && withPlaceholder">
        {{ placeholder }}
      </template>

      <template v-else>
        <MedTooltip :content="value">
          <span>{{ value }}</span>
        </MedTooltip>
      </template>
    </div>

    <template v-if="helperText">
      <div class="mt-1 flex cursor-default justify-between space-x-2">
        <span class="text-xs text-gray-500">{{ helperText }}</span>
      </div>
    </template>
  </div>
</template>
